import Image from 'next/image';
import { FC, useMemo, useState } from 'react';

import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

import Modal from '~components/ui/Modal';
import ShadowImage from '~components/ui/ShadowImage';

import { Attachment } from '~types';

import s from './Gallery.module.css';

interface Props {
  images: Attachment[];
}

const Gallery: FC<Props> = ({ images }) => {
  //const [selectedImage, setSelectedImage] = useState<Attachment>();
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const selectedImage = useMemo(() => {
    if (selectedIndex === null) {
      return null;
    }
    return images.at(selectedIndex);
  }, [selectedIndex]);
  return (
    <>
      <div className={s.root}>
        {images.map((image, index) => (
          <a href="#" onClick={() => setSelectedIndex(index)} key={image.tmpDir}>
            <ShadowImage data={image} className={s.img} version="url" />
          </a>
        ))}
      </div>
      <Modal onClose={() => setSelectedIndex(null)} open={!!selectedImage}>
        <div className="relative aspect-video w-[calc(100vw_-_32px)] max-w-[1024px] overflow-hidden rounded-2xl bg-black">
          {!!selectedImage && (
            <Image src={selectedImage.url} fill className="object-cover" alt="" />
          )}
          <button
            className="rounded-full bg-black/20 w-12 h-12 text-white absolute bottom-3 right-3 flex justify-center items-center backdrop-blur-2xl hover:bg-black/30 transition-colors"
            onClick={() => {
              if (selectedIndex !== null) {
                setSelectedIndex(images.length === selectedIndex + 1 ? 0 : selectedIndex + 1);
              }
            }}
          >
            <ArrowRightOutlined />
          </button>
          <button
            className="rounded-full bg-black/20 w-12 h-12 text-white absolute bottom-3 right-16 flex justify-center items-center backdrop-blur-2xl hover:bg-black/30 transition-colors"
            onClick={() => {
              if (selectedIndex !== null) {
                setSelectedIndex(selectedIndex === 0 ? images.length - 1 : selectedIndex - 1);
              }
            }}
          >
            <ArrowLeftOutlined />
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Gallery;
